import { Loader } from '@googlemaps/js-api-loader';
import { stateCodeMapping } from '~/lib/constants';

const GOOGLE_API_KEY = 'AIzaSyBjLbRXGWDLo3Iv2vEJ2M1f_Es8kO_iRNk';

let googleLoaderPromise = null;

function loadGoogleMaps() {
  if (!googleLoaderPromise) {
    const loader = new Loader({
      apiKey: GOOGLE_API_KEY,
      libraries: ['places'],
    });
    googleLoaderPromise = loader.load();
  }
  return googleLoaderPromise;
}

export class AddressSuggest {
  constructor(inputElement, options = {}) {
    this.input = inputElement;
    this.onSelect = options.onSelect || (() => {});
    this.autocomplete = null;
  }

  attach() {
    this.initGoogleAutocomplete();
    return this;
  }

  destroy() {
    if (this.autocomplete) {
      google.maps.event.clearInstanceListeners(this.autocomplete);
      this.autocomplete = null;
    }
  }

  async initGoogleAutocomplete() {
    try {
      await loadGoogleMaps();

      this.autocomplete = new google.maps.places.Autocomplete(this.input, {
        componentRestrictions: { country: ['us'] },
        fields: ['address_components', 'geometry'],
        types: ['address'],
      });

      this.autocomplete.addListener('place_changed', () => this.handlePlaceChanged());
    } catch (error) {
      console.error('Google Places autocomplete error:', error);
    }
  }

  handlePlaceChanged() {
    const place = this.autocomplete.getPlace();

    if (!place.address_components) {
      return;
    }

    const addressData = this.parseGoogleAddress(place);
    this.input.value = addressData.Line1 || '';
    this.onSelect(addressData);
  }

  parseGoogleAddress(place) {
    let streetNumber = '';
    let route = '';
    let city = '';
    let stateCode = '';
    let postalCode = '';

    for (const component of place.address_components) {
      const componentType = component.types[0];

      switch (componentType) {
        case 'street_number':
          streetNumber = component.long_name;
          break;
        case 'route':
          route = component.short_name;
          break;
        case 'locality':
          city = component.long_name;
          break;
        case 'administrative_area_level_1':
          stateCode = component.short_name;
          break;
        case 'postal_code':
          postalCode = component.long_name;
          break;
        case 'postal_code_suffix':
          postalCode = `${postalCode}-${component.long_name}`;
          break;
      }
    }

    const address1 = streetNumber ? `${streetNumber} ${route}` : route;

    // Return in format compatible with existing fillInAddress functions
    return {
      Line1: address1,
      City: city,
      Province: stateCodeMapping[stateCode] || stateCode,
      ProvinceCode: stateCode,
      PostalCode: postalCode,
    };
  }
}
